import React, { useCallback } from 'react';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import metadata from './ConfirmationPage.metadata.json5';
import messages from "./ConfirmationPage.messages";
import styles from './ConfirmationPage.module.scss';

function ConfirmationPage(props) {
    const translator = useTranslator();
    const { wizardData, history } = props;

    const goToPolicy = () => {
        const policyNumber = _.get(wizardData.value, 'policyNumber');

        return history.push({ pathname: `/policies/${policyNumber}/summary` });
    };

    const goToTransaction = () => {
        const jobID = _.get(wizardData.value, 'jobID');

        return history.push({ pathname: `/change/${jobID}/summary` });
    };

    const getBillingLink = useCallback(() => {
        const redirectRoute = {
            pathname: `/policies/${_.get(wizardData.value, 'policyNumber')}/billing`,
            state: 'billingTile'
        };

        return (
            <FormattedMessage
                {...messages.paymentSchedule}
                values={{
                    link: <Link to={redirectRoute}>{translator(messages.policyBillingPage)}</Link>
                }}
            />
        );
    }, [wizardData, translator]);

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            goToTransaction,
            goToPolicy
        }
    };

    const overrideProps = {
        lobDetails: {
            content: translator(messages.lobPolicy, {
                lob: _.get(wizardData.value, 'baseData.productName'),
                policyNumber: _.get(wizardData.value, 'policyNumber')
            })
        },
        referenceNumber: {
            content: translator(messages.referenceNumber, {
                refNumber: _.get(wizardData.value, 'jobID')
            })
        },
        paymentScheduleAndInvoices: {
            content: getBillingLink()
        },
        transactionButton: {
            content: translator(messages.viewJobDetails, {
                jobType: _.get(wizardData.value, 'baseData.jobType')
            })
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={wizardData}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

ConfirmationPage.propTypes = {
    viewModelService: PropTypes.shape({
        create: PropTypes.func
    }).isRequired,
    history: PropTypes.shape({
        location: PropTypes.shape({
            state: PropTypes.shape({
                transactionSummary: PropTypes.shape({})
            }).isRequired
        }).isRequired,
        push: PropTypes.func.isRequired
    }).isRequired
};

ConfirmationPage.propTypes = wizardProps;
export default withRouter(ConfirmationPage);
